var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vxe-list',{class:{ 'rock-tree__auto-height': !_vm.height },attrs:{"size":_vm.vxeSize,"loading":_vm.loading || _vm.listLoading,"data":_vm.list,"height":_vm.height,"className":"rock-tree"},scopedSlots:_vm._u([{key:"default",fn:function({ items }){return [(_vm.list.length && !_vm.loading && !_vm.listLoading)?[_vm._l((items),function(item){return [_c('div',{key:item[_vm.props.value || 'id'],staticClass:"rock-tree-item",class:[
            `level-${item._LEVEL}`,
            {
              'has-child': item._HAS_CHILDREN,
              'is-expand': item._EXPAND,
              'is-current':
                !_vm.showCheckbox &&
                !_vm.isNull(_vm.currentKey) &&
                item[_vm.props.value || 'id'] === _vm.currentKey,
            },
          ],style:({
            paddingLeft: `${item._LEVEL * _vm.indent}px`,
            height: `${_vm.rowHeight}px`,
            lineHeight: `${_vm.rowHeight}px`,
          })},[_c('i',{staticClass:"tree-icon vxe-icon-caret-right",style:({
              padding: `${_vm.rowHeight / 2 - 6}px`,
            }),on:{"click":function($event){return _vm.toggleTreeNode(item)}}}),(
              _vm.showCheckbox &&
              (_vm.disableBranchNodes
                ? !item._HAS_CHILDREN &&
                  (_vm.lastLevelKey && !_vm.isNull(_vm.lastLevelValue)
                    ? item[_vm.lastLevelKey] === _vm.lastLevelValue
                    : true)
                : true)
            )?_c('vxe-checkbox',{attrs:{"indeterminate":item._INDETERMINATE,"title":item[_vm.props.label || 'name']},on:{"change":function($event){return _vm.handleChecked(item)}},model:{value:(item._CHECKED),callback:function ($$v) {_vm.$set(item, "_CHECKED", $$v)},expression:"item._CHECKED"}},[_vm._v(" "+_vm._s(item[_vm.props.label || "name"])+" ")]):_c('div',{staticClass:"tree-label",style:({
              width: `calc(100% - ${_vm.rowHeight}px)`,
            }),attrs:{"title":item[_vm.props.label || 'name']},on:{"click":function($event){return _vm.handleNodeClick(item)}}},[_vm._v(" "+_vm._s(item[_vm.props.label || "name"])+" ")]),_vm._t("node",null,{"node":item})],2)]})]:(!_vm.loading && !_vm.listLoading)?_c('div',{staticClass:"el-tree__empty-block"},[_c('span',{staticClass:"el-tree__empty-text"},[_vm._v(_vm._s(_vm.emptyText))])]):_vm._e()]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }